import {TextStyle} from 'react-native';

export const InputStyles = {
  inputActive: {
    borderColor: '#1F3930',
    borderWidth: 2,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    fontSize: 16,
  } as TextStyle,
  inputInactive: {
    borderColor: '#BCCD48',
    borderWidth: 1,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    fontSize: 16,
  } as TextStyle,
  // Add other input styles here...
};
